import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { CampaignLoyaltyProgramme, ForSaleCoupon, IndefiniteCoupon, IndefiniteLoyaltyProgramme, ParticipantCoupon, ScanType, Voucher, WalletCouponCardInfo } from 'src/app/models/interfaces';
import { AlertService } from 'src/app/services/alert.service';
import { AssetlinksService } from 'src/app/services/assetlinks.service';
import { DateTimeService } from 'src/app/services/date-time.service';
import { GisService } from 'src/app/services/gis.service';
import { LocationService } from 'src/app/services/location.service';
import { YumdealzUserService } from 'src/app/services/yumdealz-user.service';
import { ScanService } from 'src/app/services/scan.service';
import { OutletDealzService } from 'src/app/services/outlet-dealz.service';
import { PreferencesService } from 'src/app/services/preferences.service';
import { QrCodePage } from 'src/app/pages/wallet/modals/qr-code/qr-code.page';
import { CouponsService } from 'src/app/services/coupons.service';
import { Listing, ListSelectorData } from 'src/app/pages/wallet/modals/list-selector/interfaces';
import { ListSelectorPage } from 'src/app/pages/wallet/modals/list-selector/list-selector.page';


@Component({
  selector: 'app-coupon-card',
  templateUrl: './coupon-card.component.html',
  styleUrls: ['./coupon-card.component.scss'],
})
export class CouponCardComponent  implements OnInit,OnDestroy {
  @Input() coupon:ParticipantCoupon;
  @Input() scanRange:number;
  @Input() inMemoryCouponListing:IndefiniteCoupon|ForSaleCoupon

  couponListing:IndefiniteCoupon|ForSaleCoupon;
  isButtonLoading
  /**
  * the current day
  */
  today:"Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday" | "Saturday" | "Sunday";

  loading:boolean=true;
  cardInfo:WalletCouponCardInfo = {
    id:null,
    // kmFromSpecial:null,
    // lat:null,
    // lng:null,
    couponListingId:null,
    shopName:null
  };
  platformResumeSubscription:Subscription;

  @Output() onWantsToScan:EventEmitter<Voucher> = new EventEmitter()
  @Output() onCouponListingFetched:EventEmitter<IndefiniteCoupon|ForSaleCoupon> = new EventEmitter()
  @Output() onCardInfoEmit:EventEmitter<WalletCouponCardInfo> = new EventEmitter();
  constructor(
    public assetLinksService:AssetlinksService,
    private modalCtrl:ModalController,
    public alertService:AlertService,
    public yumDealzUserService:YumdealzUserService,
    public outletDealzService:OutletDealzService,
    public couponsService:CouponsService,
    public dateTimeService:DateTimeService,
    private locationService:LocationService,
    private gisService:GisService,
    private platform:Platform,
    private preferencesService:PreferencesService,
    public scanService:ScanService
    ) { 
     
      this.today =  this.dateTimeService.giveLocalNowDay();
      this.platformResumeSubscription = this.platform.resume.subscribe(async()=>{     
        // and other stuff should happen here if the day changed...
        this.today =  this.dateTimeService.giveLocalNowDay();
      });
    }
  
    private calcKmFromCoupon(couponListing:IndefiniteCoupon|ForSaleCoupon ){
      // if(!this.locationService.isUserLocationSet()){
      //   return null
      // }
      // return this.gisService.getDistanceFromLocation(couponListing.lng,couponListing.lat,
      //   {lng:this.locationService.userLocation.lng,lat:this.locationService.userLocation.lat}
      // )
    }

    ngOnDestroy(): void {
      if(this.platformResumeSubscription){
        this.platformResumeSubscription.unsubscribe()
      }
    }

  emitInitDetails(){
    this.onCouponListingFetched.emit(this.couponListing)
    this.cardInfo.id = this.coupon.uid,
    this.cardInfo.shopName = this.couponListing.restaurant_name
    this.cardInfo.couponListingId = this.couponListing.id
    // this.cardInfo.lat = this.couponListing.lat
    // this.cardInfo.lng = this.couponListing.lng
    // this.cardInfo.kmFromSpecial = this.calcKmFromCoupon(this.couponListing)
    this.onCardInfoEmit.emit(this.cardInfo)
  }

  async ngOnInit() {
    if(this.inMemoryCouponListing){
      this.couponListing = this.inMemoryCouponListing
      this.emitInitDetails();
    }else{
      try {
        this.couponListing = await this.outletDealzService.fetchaCouponListing(this.coupon.userId,this.coupon.restaurantUid,this.coupon.outlet_group_coupon_id);
        if(this.couponListing){
          this.emitInitDetails();
        }
      } catch (error) {
        console.log(error);
      }
    }
    this.loading = false;
  }

  async viewRestaurant(couponListing:IndefiniteCoupon|ForSaleCoupon){

  }

  async showRedemptionQrCode(){
    const modal = await this.modalCtrl.create({
      component: QrCodePage,
      mode: 'ios',
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      handle: false,
      componentProps:{
        qrcodeid:`coupon_${this.coupon.uid}_${this.coupon.outlet_id}_${this.coupon.restaurantUid}_${this.coupon.outlet_group_coupon_id}_${this.coupon.userId}`,
        coupon:this.coupon,
        qrCodeType:"Coupon"
      }
    });
    await modal.present();
  }

  async showRedemptionOptions(){
    const listItems = [
      {
       label:'Show QR Code',
       ionIcon:'qr-code',
       value:'show'
     },
     {
      label:'Scan QR Code',
      ionIcon:'scan',
      value:'scan'
    },
    ]
    if(this.scanService.isNfcSupported){
     listItems.push({
        label:'Tap a Puck',
        ionIcon:'radio',
        value:'tap'
      })
    }
    const modal = await this.modalCtrl.create({
      component: ListSelectorPage,
      mode: 'ios',
      initialBreakpoint: 0.6,
      breakpoints: [0,0.6, 1],
      handle: false,
      componentProps: {
        listings: {
          title:'Select Redemption Method',
          listItems
        } as ListSelectorData
      }
    });
  
    await modal.present();
  
    modal.onDidDismiss().then(async (result)=>{
        if(result.data){
          const listing = result.data as Listing;
          const value = listing.value as 'scan'|'tap'|'show'
          switch (value) {
            case 'scan':
              await this.redeemCoupon('QR')
              break;
            case 'tap':
              await this.redeemCoupon('NFC')
              break;
            case 'show':
              await this.showRedemptionQrCode()
              break;
            default:
              break;
          }
        }
    })
    }


   async redeemCoupon(scanType:ScanType){
    this.isButtonLoading = true;

    const scanContent = await this.scanService.scanVoucherOrCoupon(this.coupon,scanType);
    if(scanContent){
      await this.scanService.letUserRedeemCoupon(this.coupon,scanContent.outlet);
    }
    this.isButtonLoading = false;
  }

}
